import { defineComponent } from 'vue';

export default defineComponent({
  methods: {
    toggleBodyClass(addRemoveClass: string, className: string) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  mounted() {
    this.toggleBodyClass('addClass', 'modal-visible');
  },
  unmounted() {
    this.toggleBodyClass('removeClass', 'modal-visible');
  },
});
